import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
//import { MyUrl } from "../../../App";
import axios from "axios";
import edit from "../../Images/edit.png";
import delete77 from "../../Images/delete77.png";

var MyArray = [];
export default function WhiteListsFirstTable({
  onSendDataForDelete,
  onSendData,
  SendDataToFirstTable,
  startDate,
  endDate,
}) {
  const [Value, setValue] = React.useState("");
  // console.log("startDate");
  // console.log(startDate);
  // console.log("endDate");
  // console.log(endDate);
  const handleChange = (event) => {
    setValue(event.target.value);
  };
  const gridRef = useRef(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    //     setSearchText(selectedKeys[0]);
    //     setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    // setSearchText("");
  };

  const [dataToSend, setDataToSend] = useState("True");
  const [dataToSendForDelete, setdataToSendForDelete] = useState("True");

  const handleButtonClick = (
    seatId,
    id,
    sourceId,
    sourceName,
    environment,
    targeting,
    geo,
    name,
    bundlesData
  ) => {
    onSendData({
      dataToSend,
      seatId,
      id,
      sourceId,
      sourceName,
      environment,
      targeting,
      geo,
      name,
      bundlesData,
    });
  };

  const handleButtonClickForDelete = (id) => {
    onSendDataForDelete({ dataToSendForDelete, id });
  };
  const BtnCellRenderer = (rowData) => {
    return (
      <div style={{ paddingTop: 4 }}>
        <a
          style={{
            borderWidth: 0,
            color: "green",
            paddingRight: 20,
            cursor: "pointer",
          }}
          onClick={() => {
            handleButtonClick(
              rowData.data.seatId,
              rowData.data.id,
              rowData.data.sourceId,
              rowData.data.sourceName,
              rowData.data.environment,
              rowData.data.targeting,
              rowData.data.geo,
              rowData.data.name,
              rowData.data.bundlesData
            );
          }}
        >
          {/* Edit{" "} */}
          <img
            src={edit}
            style={{ width: 30, cursor: "pointer" }}
            onClick={() => {}}
          ></img>
        </a>
        {/* <button>Edit</button> */}
        {"  "}
        <a
          onClick={() => {
            handleButtonClickForDelete(rowData.data.id);
          }}
          style={{ borderWidth: 0, color: "red", cursor: "pointer" }}
        >
          {/* Delete */}
          <img
            src={delete77}
            style={{ width: 30, cursor: "pointer" }}
            onClick={() => {}}
          ></img>
        </a>
      </div>
    );
  };
  const getColumnSearchProps = (dataIndex) => ({});
  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Id",
      flex: width > 766 ? 1 : null,
      field: "id",
      //filter: true,
      filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "Name",
      flex: width > 766 ? 1 : null,
      field: "name",
      //filter: true,
      filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "Bundles",
      flex: width > 766 ? 1 : null,
      field: "bundles",
      filter: "agNumberColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "Source",
      flex: width > 766 ? 1 : null,
      field: "sources",
      filter: true,
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "Seat",
      flex: width > 766 ? 1 : null,
      field: "seatName",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
    },
    {
      headerName: "Environment",
      flex: width > 766 ? 1 : null,
      field: "environment",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
    },
    {
      headerName: "Actions",
      headerClass: "my-header-class",
      field: "Action",
      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        clicked: function (field) {
          alert(`${field} was clicked`);
        },
      },
    },
  ]);
  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true,
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  // Example using Grid's API
  const buttonListener = useCallback((e) => {
    gridRef.current.api.deselectAll();
  }, []);
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    "rag-amber-outer": function (params) {
      return params.value === 2004;
    },
    "rag-red-outer": function (params) {
      return params.value === 2000;
    },
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === SendDataToFirstTable.length
        ? "bottom-row"
        : "";
    },
    // other grid options...
  };

  //   const columnDefs = [
  //     { headerName: "Name", field: "name" },
  //     { headerName: "Value", field: "value" },
  //   ];
  const containerStyle = useMemo(
    () => ({ width: "100%", height: height - 130 }),
    []
  );
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  useEffect(() => {
    // This code will run only when myVariable changes
    console.log(`startDate changed to ${startDate} ---- ${endDate}`);
  }, [startDate, endDate]);
  const frameworkComponents = {
    actionsCellRenderer: ActionsCellRenderer,
  };

  return (
    <div style={{ paddingBottom: 30 }}>
      <div style={containerStyle}>
        <div style={gridStyle} className="ag-theme-alpine">
          <span style={{ color: "#1a1523", fontSize: 18 }}>White Lists</span>
          <AgGridReact
            cellClassRules={ragCellClassRules}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={SendDataToFirstTable} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            rowSelection="multiple" // Options - allows click selection of rows
            onCellClicked={cellClickedListener} // Optional - registering for Grid Event
            onGridReady={onGridReady}
            gridOptions={gridOptions}
            suppressScrollOnNewData={true}
            getRowHeight={getRowHeight}
            //domLayout="autoHeight"
            pagination={true}
            paginationPageSize={100}
            frameworkComponents={frameworkComponents}
          />
        </div>{" "}
      </div>{" "}
      <style>
        {`
                      .ag-theme-alpine .ag-root-wrapper {
                        border: none;
                      }
                    `}
        {`
                      .my-header-class {
                        background-color: white;
                      }
                    `}
        {`
             .ag-header-cell {
              background-color: white;
          }`}
      </style>
    </div>
  );
}

const ActionsCellRenderer = (props) => {
  const handleButtonClick = () => {
    // Add your button click logic here
    console.log(`Button clicked for row with ID: ${props.data.id}`);
  };

  return <button onClick={handleButtonClick}>Click Me</button>;
};
